import React, { Suspense } from 'react';
import { Switch, Route } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { layoutTypes } from "../components/constants/layout";
import NonAuthLayout from "../Layout/NonAuthLayout";
import VerticalLayout from "../Layout/VerticalLayout/Index";
// import HorizontalLayout from "../Layout/HorizontalLayout/Index";
import { adminRoutes, psychologistRoutes, publicRoutes } from "./allRoutes";
import Page404 from '@/pages/Page404';
import PrivateRoute from "./PrivateRoute";
import { useHistory } from "react-router-dom";
import { ADMIN_ROLE, PSYCHOLOGIST_ROLE } from "@/configs";
import { Spinner } from 'reactstrap';

// const getLayout = (layoutType) => {
//   let Layout = VerticalLayout;
//   switch (layoutType) {
//     case layoutTypes.VERTICAL:
//       Layout = VerticalLayout;
//       break;
//     case layoutTypes.HORIZONTAL:
//       Layout = HorizontalLayout;
//       break;
//     default:
//       break;
//   }
//   return Layout;
// };

const Routes = ({ role }) => {
  const availablePublicRoutesPaths = publicRoutes.map((r) => r.path);
  const availableRoutes = {
    [ADMIN_ROLE]: adminRoutes,
    [PSYCHOLOGIST_ROLE]: psychologistRoutes,
  };
  const availableRoutesPaths = {
    [ADMIN_ROLE]: adminRoutes.map((r) => r.path),
    [PSYCHOLOGIST_ROLE]: psychologistRoutes.map((r) => r.path)
  }
  // const availableAdminRoutesPaths = adminRoutes.map((r) => r.path);
  // const availablePsychologistRoutesPaths = psychologistRoutes.map((r) => r.path);

  // const { layoutType } = useSelector((state) => ({
  //   layoutType: state.Layout.layoutType,
  // }));

  // const Layout = getLayout(layoutType);
  const Layout = VerticalLayout;
  const history = useHistory();

  return (
    <Switch>
      <Route path={availablePublicRoutesPaths}>
        <NonAuthLayout>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <Route
                path={route.path}
                component={route.component}
                key={idx}
                exact={true}
              />
            ))}
          </Switch>
        </NonAuthLayout>
      </Route>

      {!!role && (
        <PrivateRoute
          path={availableRoutesPaths[role]}
          history={history}
          role={role}
        >
          <Layout>
            <Switch>
              {availableRoutes[role].map((route, idx) => (
                <RouteWithProps
                  path={route.path}
                  component={route.component}
                  key={idx}
                  exact={true}
                  params={{ role }}
                />
              ))}
              <Route path="*" component={Page404} />
            </Switch>
          </Layout>
        </PrivateRoute>
      )}

      {/* <Route path="/login" component={Login} /> */}
      {/* <Route path="/reset-password" component={ResetPassword} /> */}
      {/* <Route path="/account-activation" component={AccountActivation} /> */}

      {/* <PrivateRoute
        path={availableAdminRoutesPaths}
        history={history}
        role={ADMIN_ROLE}
        redirect="/cabinet/profile"
      >
        <Layout>
          <Switch>
            {adminRoutes.map((route, idx) => (
              <RouteWithProps
                path={route.path}
                component={route.component}
                key={idx}
                exact={true}
                params={{ role: route.role }}
              />
            ))}
            <Route path="*" component={Page404} />
          </Switch>
        </Layout>
      </PrivateRoute>

      <PrivateRoute
        path={availablePsychologistRoutesPaths}
        history={history}
        role={PSYCHOLOGIST_ROLE}
        redirect="/admin"
      >
        <Layout>
          <Switch>
            {psychologistRoutes.map((route, idx) => (
              <RouteWithProps
                path={route.path}
                component={route.component}
                key={idx}
                exact={true}
                params={{ role: route.role }}
              />
            ))}
            <Route path="*" component={Page404} />
          </Switch>
        </Layout>
      </PrivateRoute> */}
      <PrivateRoute path="/" history={history} exact />
      <Route path="*" component={Page404} />
    </Switch>
  );
};

const RouteWithProps = ({ component: Component, params, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(routeProps) => (
        <Suspense
          fallback={
            <div className="page-suspense">
              <Spinner color="primary" type="grow" />
            </div>
          }
        >
          <Component {...routeProps} {...params} />
        </Suspense>
      )}
    />
  );
};

export default Routes;
